import {
  ProductSearchParams_2020_12,
  ProductSearchParams_2022_06,
  ProductSearchResponse_2020_12,
  ProductSearchResponse_2022_06,
} from '../types';
import { Session } from '../types/session';
import { rechargeApiRequest } from '../utils/request';

export type ProductSearchType<T extends ProductSearchParams_2020_12 | ProductSearchParams_2022_06> =
  T extends ProductSearchParams_2020_12 ? ProductSearchResponse_2020_12 : ProductSearchResponse_2022_06;

export async function productSearch<T extends ProductSearchParams_2020_12 | ProductSearchParams_2022_06>(
  session: Session,
  query: T
): Promise<ProductSearchType<T>> {
  if (!['2020-12', '2022-06'].includes(query.format_version)) {
    throw new Error('Missing or unsupported format_version.');
  }
  return rechargeApiRequest<ProductSearchType<T>>(
    'get',
    `/product_search`,
    {
      query,
      headers: {
        'X-Recharge-Version': '2021-01',
      },
    },
    session
  );
}
